export default __webpack_public_path__ + "static/media/soles_resume.5c76c38a.pdf";